"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../../styles");
var _constants = require("./constants");
const QRCodeSkeleton = exports.QRCodeSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  width: _constants.QR_CODE_WIDTH,
  height: _constants.QR_CODE_HEIGHT,
  borderRadius: theme.shape.borderRadius
}));